<template>
  <div class="goodsInfo">
    
    
    <Advertising />
    <Rewards />
    <div v-for="(item, index) in listDataAll" :key="index" :id="'trace' + index" class="pageContentRef_index">
      <Anti info='防伪信息' v-if="item.trace_name === '防伪信息'"/>
      <Tem v-if="item.trace_name === '商品信息'"/>
      <Enterprise v-if="item.trace_name === '企业信息'"/>
      <Tradeinfo v-if="item.trace_name === '流通信息'"/>
      <QualityTesting  v-if="item.trace_name === '质检信息'"/>
      <diy2 v-if="isNaN(Number(item.trace_id))" :dataList="item"/>
      
    </div>
    
    <ewm />
    <!-- <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <div class="block">
          <div class="t-info">张晓霞先生</div>
          <div></div>
          <div class="f-info">欢迎您使用我们的链宇宙产品， 再接下来我们与您同在</div>
        </div>
      </div>
    </van-overlay> -->
  </div>
</template>
<script>
import Vue from "vue";

import { Toast } from "vant";
import { Overlay } from 'vant';

Vue.use(Overlay);

Vue.use(Toast);
// import PageContent from "../components/templateContent";
// import MapCp from "../components/map.vue";
// import SecurityInfo from "./SecurityInfo.vue";
// import EnterpriseInfo from "@/views/EnterpriseInfo";
// import QsInfo from "@/views/QsInfo";
// import CirculationInfo from "@/views/CirculationInfo";
// import Intelligent from "@/views/Intelligent";
// import PlantInfo from "@/views/PlantInfo";
import Anti from './anti-fake.vue'
import Advertising from './advertising.vue'
import Rewards from './rewards.vue'
import Tem from './tem.vue'
import Enterprise from './enterprise.vue'
import QualityTesting from './qualityTesting.vue'
import ewm from './ewm.vue'
import Tradeinfo from './Tradeinfo.vue'
// import Diy from './diy.vue';

import Diy2 from './diy2.vue';
// import Test from './test.vue';
export default {
  computed: {
    getShopImageList() {
      return function (obj) {
        if (!obj) {
          return [];
        } else if (typeof obj[0] == "string") {
          return obj;
        } else if (typeof obj[0] == "object") {
          return obj.map((v) => {
            return v.url;
          });
        }
      };
    },
  },
  components: {
    // PageContent,
    // MapCp,
    // SecurityInfo,
    // EnterpriseInfo,
    // QsInfo,
    // CirculationInfo,
    // Intelligent,
    // PlantInfo,
    Anti,
    Advertising,
    Rewards,
    Tem,
    Enterprise,
    QualityTesting,
    ewm,
    Tradeinfo,
    
    // Diy,
    Diy2,
    // Test,
  },
  data() {
    let that = this;
    return {
      show: null,
      indexswiper: 0,
      testImage:
        "https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3957346327,171699722&fm=15&gp=0.jpg",
      listData: {},
      isShowiMmage: true,
      materialData: {},
      lats: 13,
      longs: 13,
      swiperOption: {
        // loop: true,
        // speed: oriSpeed,
        slidesPerView: "auto",
        freeMode: true,
        direction: "vertical",
        setWrapperSize: true,
        autoHeight: true,
        on: {
          touchMove() {
            const index =
              that.$refs.mySwiper_.swiper.activeIndex >
              that.listDataAll.length - 1
                ? that.listDataAll.length - 1
                : that.$refs.mySwiper_.swiper.activeIndex;
            that.$store.commit("setMeunIndex", index);
          },
          transitionEnd() {
            if (that.$refs.mySwiper_.swiper) {
              const index =
                that.$refs.mySwiper_.swiper.activeIndex >
                that.listDataAll.length - 1
                  ? that.listDataAll.length - 1
                  : that.$refs.mySwiper_.swiper.activeIndex;
              that.$store.commit("setMeunIndex", index);
            }
          },
        },
        // autoplayDisableOnInteraction: false,
      },
      listDataAll: [],
    };
  },
  async created() {},
  mounted() {
    try {
      this.$setApptitle("链宇宙防伪溯源");
    } catch {
      console.log("not webview");
    }
    this.listDataAll = JSON.parse(
      window.localStorage.getItem("slierBarListContent")
    );
    console.log(this.listDataAll);
    // 获取原料环节;
    this.materialData = JSON.parse(window.localStorage.getItem("idInObj"))[0];
    // const toast = Toast.loading({
    //   duration: 0, // 持续展示 toast
    //   forbidClick: true,
    //   message: "查询中",
    // });
    window.addEventListener("scroll", this.upDateTop_index, true);
    this.$bus.on("menuSetBus", (id) => {
      let scrollDom = document.getElementById(id);
      let scrollDombox = document.getElementsByClassName("leftContainer")[0];
      let scrollDomboxTop = scrollDombox.scrollTop;
      let scrollDomTop = scrollDom.getBoundingClientRect().top;
      let scroll = Number(scrollDomTop) + Number(scrollDomboxTop) - 45;
      document.getElementsByClassName("leftContainer")[0].scrollTop = scroll;
    });
    // setTimeout(() => {
    //    this.show = false
    // }, 3000);
  },
  methods: {
    upDateTop_index() {
      let doms = document.getElementsByClassName("pageContentRef_index");
      
      let indexSilder = 0;
      for (let i = 0; i < doms.length; i++) {
        let thatDomTopVlalue = doms[i].getBoundingClientRect().bottom;
        if (thatDomTopVlalue > 45) {
          indexSilder = i;
          break;
        }
      }
      if (!this.$store.state.isClickMenu) {
        this.$store.commit("setMeunIndex", indexSilder);
        this.$store.commit("isClickMeunHandle", false);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.title-navToptitle {
  padding: 0 20px;
}

::v-deep .van-swipe-item {
  .imagebg {
    width: 530px;
    height: 530px;
    // border-radius: 16px;
    // background: url("https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3957346327,171699722&fm=15&gp=0.jpg")
    //   no-repeat;
    background-size: contain;
    background-position: center center;
  }
}
::v-deep .swipe {
  border-radius: 15px;
}
.goodsInfo {
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .t-info {
      text-align: center;
      width: 280px;
      height: 80px;
      line-height: 80px;
    }
    .f-info {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 52px;
      color: #FFFFFF;
      opacity: 1;
      text-align: center;
      width: 392px;
      height: 92px;
      // margin-bottom: 166px;
    }
    width: 554px;
    height: 646px;
    
    background-image: url('../assets/images/欢迎弹窗.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .content {
    font-family: PingFang SC;
    line-height: 46px;
    color: #222;

    .info-wrap {
      padding: 0 0 16px 30px;
      border-bottom: 1px solid #d4d6d5;
      font-family: PingFang SC;
      line-height: 34px;
      position: relative;

      .tle {
        margin: 20px 0;
        font-size: 28px;
        font-weight: bold;
      }

      .info {
        color: #808080;
      }

      &::before {
        content: "";
        position: absolute;
        top: 11px;
        left: 0;
        background-color: #26907a;
        width: 8px;
        height: 8px;
      }
    }
  }
}
.goods-info-box {
  width: 100%;
  .goods-info-fold-title {
    width: 100%;
    height: 96px;
    background-color: #f5f5f5;
    box-shadow: 0px 4px 8px rgba(0, 45, 41, 0.2);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    padding: 24px 20px;

    .goods-info-fold-left {
      font-size: 34px;
      color: #222;
      display: flex;
      align-items: center;
      height: 100%;
      .info-fold-line {
        width: 8px;
        height: 34px;
        background-color: #26907a;
        margin-right: 16px;
      }
    }
    .goods-info-fold-right {
      font-size: 26px;
      color: #11745f;
      display: flex;
      span {
        margin-right: 8px;
      }
      align-items: center;
      .info-fold-right-image {
        width: 20px;
        height: 20px;
        transition: all 0.2s;

        img {
          transition: all 0.2s;
          width: 100%;
          height: 100%;
        }
      }
    }
    .to-page {
      width: 20px;
      height: 64px;
      // background-color: skyblue;
      position: absolute;
      bottom: -40px;
      z-index: 999;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .to-page.right {
      right: 10px;
    }
    .topage.left {
      left: 0;
    }
  }
}

.goods-info-fold-newtitle-box {
  width: 100%;
  height: auto;

  // padding-bottom: 60px;
  transition: all 0.3s;
  .goods-info-fold-innertitle {
    width: 100%;
    height: 112px;
    // box-shadow: 0px 4px 8px rgba(0, 45, 41, 0.2);
    border-radius: 16px;
    background-color: #f5f5f5;

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 20px;
    position: relative;
    .goods-info-fold-left {
      font-size: 30px;
      color: #11745f;
      display: flex;
      height: 100%;
      align-items: center;
      .info-fold-img {
        width: 40px;
        height: 40px;
        img {
          width: 100%;
          height: 100%;
        }
        margin-right: 16px;
      }
    }
    .goods-info-fold-right {
      font-size: 26px;
      color: #11745f;

      .info-fold-right-image {
        width: 20px;
        height: 20px;
        transform: rotate(-180deg);
        transition: all 0.2s;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  // 具体盒子内容部分
  .goods-info-content {
    width: 100%;
    // height: ;
    padding-top: 48px;
    .goods-info-content-image {
      // padding: 0 40px;
      width: 530px;
      margin: 0 auto;
      // display: flex;
      // margin: 0 auto;
      // justify-content: center;
    }
  }
}
.goods-info-inner-box {
  overflow: hidden;
  transition: all 0.2s;
  margin-top: 20px;
  // padding-bottom: 20px;
}

.goods-info-fold-innertitle.active {
  // border-bottom: 1px dashed #BCBCBC;
  box-shadow: none;
  border-radius: 0;
}
.goods-info-fold-innertitle.active::before {
  content: "";
  width: 92%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  // background-color: pink;
  border-bottom: 1px dashed #bcbcbc;
  height: 1px;
}
.goods-info-collapse {
  border-radius: 16px;
  box-shadow: 0px 4px 8px rgba(0, 45, 41, 0.2);
  position: relative;
  background-color: #f5f5f5;
  z-index: 10;
}

.goods-content-allbox {
  overflow: hidden;
  transition: all 0.2s;
}
.image-alert {
  img {
    width: 300px;
    height: 300px;
  }
}
.info-wrap.qitainfo {
  border: none !important;
}
.qitainfo {
  padding: 0 0 16px 0 !important;
  .info {
    padding-left: 30px !important;
  }
}
.qitatitle {
  padding: 0 0 0 30px !important;
}

.map_box {
  width: 100%;
  height: 320px;
  // background-color: pink;
}
// .swiper-slide {
//   width: auto !important;
// }
.swiper-slide {
  text-align: center;
  font-size: 18px;
  width: 100%;
  // height: 200px;
  // max-height: calc(100vh - 88px);
  height: auto !important;
  position: relative;
  /* Center slide text vertically */
}
.swiper_right {
  height: 100vh !important;
}
</style>
